import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Divider extends React.Component {
  constructor(props) {
    super(props)
    
    this.config = {
      types : [
        {
          title: 'primary',
          isDefault: true,
        },
        'inverse'
      ],
      modifiers : [],
      states : []
    }
  }
 
  render() {
    const { dataDivider, ...rest } = this.props
    
    return <hr {...rest} className={resolveProps(this.props, this.config, 'Divider')} />
  }
}

Divider.propTypes = {
  dataDivider : PropTypes.array
}